import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "order" }
const _hoisted_2 = { class: "flash-messages" }
const _hoisted_3 = { class: "order-header-btns" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg" }, "Låse opp", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg" }, "Lås", -1)
const _hoisted_6 = {
  class: "details",
  id: "orderDetails"
}
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "order-number" }
const _hoisted_9 = {
  key: 0,
  class: "weborder-number"
}
const _hoisted_10 = { class: "created-string" }
const _hoisted_11 = { class: "order-status" }
const _hoisted_12 = {
  key: 0,
  class: "label"
}
const _hoisted_13 = {
  key: 1,
  class: "pickup-buttons"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "picked-up-text"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "order-status-text" }, "Venter betaling"),
  /*#__PURE__*/_createElementVNode("p", { class: "small-gray-text" }, " Blir automatisk kansellert etter 24 timer dersom betaling ikke kommer gjennom ")
], -1)
const _hoisted_17 = {
  key: 1,
  class: "picked-up-text"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "order-status-text" }, "Ordre kansellert", -1)
const _hoisted_19 = {
  key: 2,
  class: "picked-up-text"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "order-status-text" }, "Ordre hentet", -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "register-select" }
const _hoisted_24 = { class: "label" }
const _hoisted_25 = { class: "customer" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  class: "label customer__label",
  for: "customerSelect"
}, "Kunde", -1)
const _hoisted_27 = { class: "field-error" }
const _hoisted_28 = {
  key: 0,
  class: "label"
}
const _hoisted_29 = { class: "field-error" }
const _hoisted_30 = {
  key: 1,
  class: "label"
}
const _hoisted_31 = { class: "comments" }
const _hoisted_32 = {
  class: "products",
  id: "productsScrollable",
  "scroll-region": ""
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h2", null, "Varer", -1)
const _hoisted_34 = {
  key: 0,
  class: "add-product"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "label" }, "Legg til vare", -1)
const _hoisted_36 = { class: "summary" }
const _hoisted_37 = {
  key: 0,
  class: "payment-info"
}
const _hoisted_38 = { class: "totals" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "label" }, "Totalt", -1)
const _hoisted_40 = { class: "no-wrap" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "label mva-label" }, "Herav mva", -1)
const _hoisted_42 = { class: "no-wrap mva" }
const _hoisted_43 = {
  key: 1,
  class: "add-bags-buttons"
}
const _hoisted_44 = {
  key: 2,
  class: "admin-buttons"
}
const _hoisted_45 = { class: "already-open-modal" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("p", null, "Du kan dermed ikke redigere denne ordren her.", -1)
const _hoisted_47 = { class: "buttons" }
const _hoisted_48 = { class: "sms-modal" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("h3", null, "Send SMS", -1)
const _hoisted_50 = {
  key: 0,
  class: "no-customer-phone-number"
}
const _hoisted_51 = { class: "label" }
const _hoisted_52 = { class: "field-error" }
const _hoisted_53 = { class: "label" }
const _hoisted_54 = { class: "field-error" }
const _hoisted_55 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Messages = _resolveComponent("Messages")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_CashRegisterSelect = _resolveComponent("CashRegisterSelect")!
  const _component_CustomerSelect = _resolveComponent("CustomerSelect")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Comments = _resolveComponent("Comments")!
  const _component_SaveDisplay = _resolveComponent("SaveDisplay")!
  const _component_OrderLines = _resolveComponent("OrderLines")!
  const _component_AddProduct = _resolveComponent("AddProduct")!
  const _component_Payments = _resolveComponent("Payments")!
  const _component_PaymentInfo = _resolveComponent("PaymentInfo")!
  const _component_AddBags = _resolveComponent("AddBags")!
  const _component_CompletedActions = _resolveComponent("CompletedActions")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Messages),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          class: "home-button",
          color: "white",
          type: "inertia-link",
          href: _ctx.homeLink
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SvgIcon, {
              type: "mdi",
              path: _ctx.homeIcon
            }, null, 8, ["path"])
          ]),
          _: 1
        }, 8, ["href"]),
        _createVNode(_component_Button, {
          color: "accent",
          type: "a",
          class: "back-button",
          onClick: _ctx.back
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SvgIcon, {
              type: "mdi",
              path: _ctx.leftArrowIcon
            }, null, 8, ["path"]),
            _createTextVNode("Tilbake ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.order.locked && !_ctx.isWeborder && _ctx.isAdmin)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.unlockOrder(_ctx.order.id))),
              color: "red",
              class: "lock-btn"
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createVNode(_component_SvgIcon, {
                  class: "",
                  width: "1.2rem",
                  height: "1.2rem",
                  type: "mdi",
                  path: _ctx.mdiLock
                }, null, 8, ["path"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.order.locked && !_ctx.isWeborder && _ctx.isAdmin)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.lockOrder(_ctx.order.id))),
              color: "green",
              class: "lock-btn"
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_SvgIcon, {
                  class: "text-green",
                  width: "1.2rem",
                  height: "1.2rem",
                  type: "mdi",
                  path: _ctx.mdiLockOpenVariant
                }, null, 8, ["path"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("main", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h1", _hoisted_8, "Ordre #" + _toDisplayString(_ctx.order.id), 1),
        (_ctx.order.wc_order_id)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_9, " Nettbutikk #" + _toDisplayString(_ctx.order.wc_order_id), 1))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_10, "Opprettet " + _toDisplayString(_ctx.created_at_string), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.isWeborder)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.order.shipping)
                ? (_openBlock(), _createElementBlock("label", _hoisted_12, [
                    _createTextVNode(" Status "),
                    _createVNode(_component_Multiselect, {
                      disabled: _ctx.already_opened,
                      onChange: _ctx.sendOrderForm,
                      mode: "single",
                      options: _ctx.statuses,
                      canClear: false,
                      modelValue: _ctx.orderForm.status,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.orderForm.status) = $event))
                    }, null, 8, ["disabled", "onChange", "options", "modelValue"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_ctx.order.status === 'Mottatt')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_Button, {
                            onClick: _ctx.sendOrder,
                            color: "green"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_SvgIcon, {
                                type: "mdi",
                                path: _ctx.cartUpIcon
                              }, null, 8, ["path"]),
                              _createTextVNode("Ordre hentet ")
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_Button, {
                            onClick: _ctx.cancelOrder,
                            color: "red"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_SvgIcon, {
                                type: "mdi",
                                path: _ctx.cancelIcon
                              }, null, 8, ["path"]),
                              _createTextVNode("Kansellert ")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          (_ctx.order.status === 'Venter betaling')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createVNode(_component_SvgIcon, {
                                  class: "icon",
                                  type: "mdi",
                                  path: _ctx.clockIcon
                                }, null, 8, ["path"]),
                                _hoisted_16
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.order.status === 'Kansellert')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createVNode(_component_SvgIcon, {
                                  class: "icon cancelled",
                                  type: "mdi",
                                  path: _ctx.cancelIcon
                                }, null, 8, ["path"]),
                                _hoisted_18
                              ]))
                            : (_ctx.order.status === 'Sendt')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createVNode(_component_SvgIcon, {
                                    class: "icon completed",
                                    type: "mdi",
                                    path: _ctx.cartUpIcon
                                  }, null, 8, ["path"]),
                                  _hoisted_20
                                ]))
                              : _createCommentVNode("", true),
                          (
                    _ctx.order.status === 'Sendt' || _ctx.order.status === 'Kansellert'
                  )
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 3,
                                class: "undo-button",
                                onClick: _ctx.undoComplete,
                                color: "blue"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_SvgIcon, {
                                    class: "icon",
                                    type: "mdi",
                                    path: _ctx.undoIcon
                                  }, null, 8, ["path"]),
                                  (_ctx.order.status === 'Sendt')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Ikke hentet"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_22, "Ikke kansellert"))
                                ]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                  ]))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("label", _hoisted_24, [
          _createTextVNode(" Velg kasse "),
          _createVNode(_component_CashRegisterSelect, { cash_registers: _ctx.cash_registers }, null, 8, ["cash_registers"])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _createVNode(_component_CustomerSelect, {
          id: "customerSelect",
          onChange: _ctx.sendOrderForm,
          disabled: !_ctx.orderIsEditable,
          modelValue: _ctx.orderForm.client,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.orderForm.client) = $event)),
          required: true
        }, null, 8, ["onChange", "disabled", "modelValue"]),
        _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.orderForm.errors.client), 1),
        (_ctx.order.client !== 1)
          ? (_openBlock(), _createElementBlock("label", _hoisted_28, [
              _createTextVNode(" Kundekommentar "),
              _createVNode(_component_Textarea, {
                onChange: _ctx.sendOrderForm,
                modelValue: _ctx.orderForm.comment_client,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.orderForm.comment_client) = $event))
              }, null, 8, ["onChange", "modelValue"]),
              _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.orderForm.errors.comment_client), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.orderForm.customer_note)
          ? (_openBlock(), _createElementBlock("label", _hoisted_30, [
              _createTextVNode(" Kundenotat "),
              _createVNode(_component_Textarea, {
                readonly: "",
                "model-value": _ctx.orderForm.customer_note ?? ''
              }, null, 8, ["model-value"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createVNode(_component_Comments, {
          onInputs: _ctx.sendOrderForm,
          orderComment: _ctx.orderForm.comment_order,
          "onUpdate:orderComment": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.orderForm.comment_order) = $event)),
          invoiceComment: _ctx.orderForm.comment_invoice,
          "onUpdate:invoiceComment": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.orderForm.comment_invoice) = $event)),
          orderError: _ctx.orderForm.errors.comment_order,
          invoiceError: _ctx.orderForm.errors.comment_invoice,
          invoiceId: _ctx.order.invoice?.id,
          customer_note: _ctx.order.customer_note
        }, null, 8, ["onInputs", "orderComment", "invoiceComment", "orderError", "invoiceError", "invoiceId", "customer_note"]),
        _createVNode(_component_SaveDisplay, {
          form: _ctx.orderForm,
          eager: true
        }, null, 8, ["form"])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createVNode(_component_OrderLines)
      ])
    ]),
    (_ctx.orderIsEditable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _hoisted_35,
          _createVNode(_component_AddProduct)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("aside", _hoisted_36, [
      _createVNode(_component_Button, {
        type: "inertia-link",
        href: _ctx.createOrderUrl,
        class: "summary-button",
        color: "accent"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SvgIcon, {
            type: "mdi",
            path: _ctx.newIcon
          }, null, 8, ["path"]),
          _createTextVNode("Ny ordre ")
        ]),
        _: 1
      }, 8, ["href"]),
      _createVNode(_component_Payments),
      (_ctx.payed || _ctx.isInvoiced)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _createVNode(_component_PaymentInfo)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_38, [
        _hoisted_39,
        _createElementVNode("h3", null, [
          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.toCurrency(_ctx.orderTotalIncMva, true)) + ",-", 1)
        ]),
        _hoisted_41,
        _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.toCurrency(_ctx.orderTotalIncMva - _ctx.orderTotalExMva, true)) + ",-", 1)
      ]),
      (_ctx.orderIsEditable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
            _createVNode(_component_AddBags)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_CompletedActions),
      (_ctx.isAdmin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            (_ctx.isAdmin && !_ctx.payed && !_ctx.isInvoiced)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "summary-button md",
                  disabled: !_ctx.orderIsEditable,
                  color: "white",
                  onClick: _ctx.archiveOrder
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Arkiver ordre")
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isOpenElsewhere && _ctx.lookAtAlreadyOpenOrder === false)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          "with-card": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("h3", null, " Denne ordren er åpen i en annen " + _toDisplayString(_ctx.openElsewhereLocation === "other-tab" ? "fane" : "kasse"), 1),
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_Button, {
                  color: "blue",
                  type: "inertia-link",
                  href: _ctx.createOrderUrl
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Lag ny ordre")
                  ]),
                  _: 1
                }, 8, ["href"]),
                _createVNode(_component_Button, {
                  color: "blue",
                  type: "a",
                  href: "/cash-till/open-orders/"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Gå til ordrelisten")
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  color: "gray",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.lookAtAlreadyOpenOrder = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Se på, men ikke røre")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showSMSModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          "with-card": true,
          onDismiss: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showSMSModal = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_48, [
              _hoisted_49,
              (!_ctx.order?.client_model?.phone)
                ? (_openBlock(), _createElementBlock("p", _hoisted_50, " Kunden har ikke lagt til mobilnummeret sitt! "))
                : _createCommentVNode("", true),
              _createElementVNode("label", _hoisted_51, [
                _createTextVNode(" Mobilnummer "),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.smsForm.phone_number) = $event)),
                  class: "sms-phone-number"
                }, null, 512), [
                  [_vModelText, _ctx.smsForm.phone_number]
                ]),
                _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.smsForm.errors.phone_number), 1)
              ]),
              _createElementVNode("label", _hoisted_53, [
                _createTextVNode(" Melding "),
                _createVNode(_component_Textarea, {
                  modelValue: _ctx.smsForm.message,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.smsForm.message) = $event)),
                  rows: "10",
                  cols: "50",
                  class: "sms-textarea"
                }, null, 8, ["modelValue"]),
                _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.smsForm.errors.message), 1)
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createVNode(_component_Button, {
                  onClick: _ctx.sendSMS,
                  disabled: _ctx.smsForm.processing,
                  color: "blue"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Send")
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}